const STRATEGIES_KEY = "now-algo-strategies";
const DRAFT_KEY = "now-strategy-draft";

export const getStrategies = () => {
  try {
    return JSON.parse(localStorage.getItem(STRATEGIES_KEY)) || [];
  } catch {
    return [];
  }
};

export const saveStrategies = (strategies) =>
  localStorage.setItem(STRATEGIES_KEY, JSON.stringify(strategies));

export const getStrategy = (id) =>
  getStrategies().find((strategy) => strategy.id === id);

export const createStrategy = (draft, status = "DRAFT") => {
  const strategy = {
    ...draft,
    id: `STR-${Date.now()}`,
    status,
    pnl: 0,
    createdAt: new Date().toISOString(),
  };
  saveStrategies([...getStrategies(), strategy]);
  sessionStorage.removeItem(DRAFT_KEY);
  return strategy;
};

export const updateStrategyStatus = (id, status) => {
  const next = getStrategies().map((strategy) =>
    strategy.id === id ? { ...strategy, status } : strategy
  );
  saveStrategies(next);
  return next;
};

export const deleteStrategy = (id) =>
  saveStrategies(getStrategies().filter((strategy) => strategy.id !== id));

export const getDraft = () => {
  try {
    return JSON.parse(sessionStorage.getItem(DRAFT_KEY)) || {};
  } catch {
    return {};
  }
};

export const updateDraft = (values) => {
  const draft = { ...getDraft(), ...values };
  sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  return draft;
};
